import { AxiosError } from 'axios'

const VERSION_CONFLICT_MESSAGE =
  'This data has been updated by another user. Please refresh the page to get the latest version before editing.'

const PLAN_FROZEN_MESSAGE =
  'This plan is frozen. Unfreeze it before making changes.'

export function isPlanFrozenError(error: unknown): boolean {
  if (!(error instanceof AxiosError)) return false
  if (error.response?.status !== 409) return false
  const type: string = error.response.data?.type ?? ''
  return /plan-frozen$/i.test(type)
}

export function getErrorMessage(
  error: unknown,
  fallback = 'An unexpected error occurred'
): string {
  if (error instanceof AxiosError) {
    if (error.response?.status === 409) {
      if (isPlanFrozenError(error)) return PLAN_FROZEN_MESSAGE
      const detail: string = error.response.data?.detail ?? ''
      if (/version/i.test(detail)) return VERSION_CONFLICT_MESSAGE
    }
    return error.response?.data?.detail ?? fallback
  }
  if (error instanceof Error) return error.message
  return fallback
}

export function getErrorRowIds(error: unknown): string[] {
  if (!(error instanceof AxiosError)) return []
  const rowIds = error.response?.data?.row_ids
  if (!Array.isArray(rowIds)) return []
  return rowIds.filter((id): id is string => typeof id === 'string')
}
